import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

import CookiePreferencesContent from 'components/CookiePreferencesContent';

import {getOverlayStyles, getContentStyles} from './styles';

class CookieDialog extends Component {
  render() {
    const {
      cookiePreference,
      acceptAllCookies,
      setCookiePreferenceOption,
      savePreferences,
      isMobile,
      isOpen,
      goToPrivacyPage,
      onClose,
      ModalComponent,
      consentCookiesMutation,
      savePreferenceButtonLoading,
      acceptAllCookiesButtonLoading
    } = this.props;

    const styles = {
      overlay: getOverlayStyles(isMobile),
      content: getContentStyles(isMobile)
    };

    return (
      <ModalComponent style={styles} isOpen={isOpen} onRequestClose={onClose} ariaHideApp={false}>
        <CookiePreferencesContent
          isMobile={isMobile}
          onClose={onClose}
          acceptAllCookies={acceptAllCookies}
          cookiePreference={cookiePreference}
          setCookiePreferenceOption={setCookiePreferenceOption}
          savePreferences={savePreferences}
          goToPrivacyPage={goToPrivacyPage}
          savePreferenceButtonLoading={savePreferenceButtonLoading}
          acceptAllCookiesButtonLoading={acceptAllCookiesButtonLoading}
          consentCookiesMutation={consentCookiesMutation}
        />
      </ModalComponent>
    );
  }
}

export default injectIntl(CookieDialog);
